var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"tw-w-10 lg:tw-sticky lg:tw-top-0 lg:tw-z-1"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }